<template>
<div>
<cIndex  ref="header"></cIndex>
	<div class="setpassword-content">
		<el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" class="demo-ruleForm" label-position="top">
			<el-form-item label="原密码">
				<el-input type="password" v-model="ruleForm2.oldPassword"></el-input>
			</el-form-item>
			<el-form-item label="请输入新密码" prop="pass">
				<el-input type="password" v-model="ruleForm2.pass" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="再次输入密码" prop="checkPass">
				<el-input type="password" v-model="ruleForm2.checkPass" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item class="setpassword-button">
				<a :plain="true" type="primary" class="fanhui" @click = "$router.back(-1)">返回</a>
				<a :plain="true" type="primary" @click="submitForm('ruleForm2')" class="submits">提交</a>
			</el-form-item>
		</el-form>
	</div>
</div>
</template>
<style lang="scss">
 	@import "../styles/core/reset.scss";
	.setpassword-content {
		width: 3rem;
		background: #fff;
		margin: .2rem auto 0 auto;
		padding: 2.47rem 3.42rem 2.07rem 3.65rem;
		box-shadow: 0 0 3px #C3C3C3;
		.el-form{
			.el-form-item{
				.el-form-item__label{
					font-size: 14px;
					color: #999999;
				}
				.el-form-item__content{
					.el-input{
						.el-input__inner{
							background: #F4F5F8;
							border: 1px solid #EEEEEE;
							border-radius: 4px;
						}
					}
				}
			}
			.el-form--label-top {
				.el-form-item__label {
					float: none;
					display: block;
					text-align: left;
				}
			}
			.setpassword-button{
				display: flex;
				justify-content: center;
				padding-top: .73rem;
				a {
					display: inline-block;
					width: 1.2rem;
					height: 0.40rem;
					text-align: center;
					line-height: 0.40rem;
					background: #999999;
					color: #FFFFFF;
					border-radius: 0.04rem;
				}
				.fanhui {
					margin-right: 0.30rem;
					cursor: pointer;
				}
				.submits {
					margin-left: .15rem;
					background: #555555;
					cursor: pointer;
				}
			}
		}
		.el-form-item__error {
			color: #ff4949;
			font-size: .12rem;
			line-height: .36rem;
			position: absolute;
			top: 0;
			right: .08rem;
			padding: 0 .08rem;
			left: auto;
		}
	}
</style>
<script>
	import cIndex from '@/components/header'
	const components = {
		cIndex
	}
	export default {
		components: components,
		name: 'hello',
		data() {
				var oldPassword = (rule, value, callback) => {
					if (value === '') {
						callback(new Error('请输入密码'));
					} else {
						callback();
					}
				};
				var validatePass = (rule, value, callback) => {
					if (value === '') {
						callback(new Error('请输入新密码'));
					} else {
						if (this.ruleForm2.checkPass !== '') {
							this.$refs.ruleForm2.validateField('checkPass');
						}
						callback();
					}
				};
				var validatePass2 = (rule, value, callback) => {
					if (value === '') {
						callback(new Error('请再次输入密码'));
					} else if (value !== this.ruleForm2.pass) {
						callback(new Error('两次输入密码不一致!'));
					} else {
						callback();
					}
				};
				return {
					ruleForm2: {
						pass: '',
						checkPass: '',
						oldPassword: '',
					},
					rules2: {
						oldPassword: [{
							validator: oldPassword,
							trigger: 'blur'
						}],
						pass: [{
							validator: validatePass,
							trigger: 'blur'
						}],
						checkPass: [{
							validator: validatePass2,
							trigger: 'blur'
						}]
					}
				};
			},
			methods: {
				submitForm(formName) {
					this.$refs[formName].validate((valid) => {
						if (valid) {
							this.$http.post(urls.urltest + "/personal/updatePassword.json", {
									token: localStorage.getItem("token"),
									oldPassword: this.ruleForm2.oldPassword,
									newPassword: this.ruleForm2.checkPass,
									phone: localStorage.getItem("phone")
								})
								.then(function(res) {
									if (res.body == true) {
										this.$message({
											type: 'info',
											message: `修改密码成功为您跳转到登录页`
										});
										var _this = this
										setTimeout(function() {
											_this.$router.replace("/")
										}, 2000)
									}else{
										this.$message({
											type: 'error',
											message: `原密码不正确请输入正确密码`
										});
									}
								})
						} else {
							return false;
						}
					});
				},
				resetForm(formName) {
					this.$refs[formName].resetFields();
				},
			}
	}
</script>


// WEBPACK FOOTER //
// setpassword.vue?7f5967b0